import React from "react";
import { Form, Input } from "antd";
import PhoneInput from "react-phone-input-auto-format";

const FormItemPhoneNumber = ({
  label,
  name,
  form,
  rules = [],
  placeholder = "Enter Phone Number",
  disabled = false,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
      <PhoneInput
        placeholder={placeholder}
        inputComponent={Input}
        autoComplete="off"
        disabled={disabled}
        onChange={(value) => {
          const digits = value ? value.replace(/\D/g, "") : "";
          form.setFieldsValue({ [name]: digits });
        }}
      />
    </Form.Item>
  );
};

export default FormItemPhoneNumber;
